module.exports = __webpack_public_path__ + "static/media/mpl-footer.a7c47804.jpg";